const isStage = false

export const sysVersion = "1.5.38";
export let apiUrl = "";
export let webAppUrl = "";
export let boUrl = "";
export let wsUrl = ""
export const imageUrl = "https://api.mybee.services";

export const SITE_KEY_V3 = "6LcQIzgqAAAAAFbBxApOttqBJeteXUe8N69rg9de";
export const SITE_KEY_V2 = "6LeN_zcqAAAAAKdz6GpxoURmaecThbf_gRQUunLa";
export const NOTIFICATION_PUBLIC_KEY = "BOHOgpVmzisGmHqxlW1HxKxFPd87FvI0fWOWnT1QRt0wPMt6G3kQr75lH9UshNGXUP6mZPYbDHyL-9P0QFxgTQQ"

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  // apiUrl = "http://192.168.1.105:3000";
  apiUrl = "http://localhost:3000";
  webAppUrl = "http://localhost:3002";
  boUrl = "http://localhost:3001";
  wsUrl = 'ws://localhost:3000';
}
else if (isStage) {
  apiUrl = "https://api.mybee.services";
  webAppUrl = "https://mybee.services";
  boUrl = "https://mybee-bo-stage.onrender.com";
  wsUrl = 'wss://api.mybee.services';
}
else {
  apiUrl = "https://api.mybee.services";
  webAppUrl = "https://mybee.services";
  boUrl = "https://bo.mybee.services";
  wsUrl = 'wss://api.mybee.services';
}
